import { Answer } from '@/gql/graphql';
import { answerQuestion } from '@/pages/products/products.requests';
import { answerTemplateQuestion } from '@/pages/templates/templates.requests';
import { useUiStore } from '@/store/ui.store';
import { useMutation } from '@apollo/client';

export const useAnswerQuestion = (id?: string) => {
  const { setLastSavedProduct } = useUiStore((state) => state);
  const [answerQuestionMutation, { loading }] = useMutation(answerQuestion);
  const [answerTemplateQuestionMutation, { loading: templateAnswerLoading }] = useMutation(answerTemplateQuestion);

  const answerSingleQuestion = async (questionId: string, answer: Answer) => {
    await answerQuestionMutation({
      variables: {
        answerPretailoringInput: {
          questionId,
          productId: id || '',
          answer,
        },
      },
      onCompleted: () => {
        setLastSavedProduct(id || '', new Date());
      },
    });
  };

  const answerSingleTemplateQuestion = async (questionId: string, answer: Answer) => {
    await answerTemplateQuestionMutation({
      variables: {
        answerTemplateTailoringQuestionInput: {
          questionId,
          templateId: id || '',
          answer,
        },
      },
      onCompleted: () => {
        setLastSavedProduct(id || '', new Date());
      },
    });
  };

  return { answerSingleQuestion, answerSingleTemplateQuestion, answerLoading: loading, templateAnswerLoading };
};
